
//
// Templating
//

function templateStatusCell (voucher) {
  return (
    '<span class="tag ' + voucher.tag_class + '"' + (voucher.display_status === 'void' ? ' data-tooltip="' + voucher.void_reason + '" data-tooltip-style="negative"' : '') + '>' +
       voucher.display_status +
    '</span>');
}

function templateVoucherTypeIcon (voucher) {
  return (voucher.voucher_type === 'offer'
    ? '<i data-icon="' + voucher.voucher_type + '" data-tooltip="' + voucher.offer_code + '"></i>'
    : '<i data-icon="' + voucher.voucher_type + '"></i>');
}

function templateRedeemCell (voucher) {
  return ( voucher.redeemable
    ? '<button class="button special" data-redeem-code="' + voucher.voucher_code + '"' +
              ' type="button"         data-redeem-vid="'  + voucher.voucher_id   + '">Redeem</button>'
    : '');
}

function templateRow (voucher) {
  return (
    '<tr data-implicit-link="' + voucher.link + '">' +
      '<td>' + voucher.voucher_code + '</td>' +
      '<td class="center">' + templateVoucherTypeIcon(voucher) + '</td>' +
      '<td>' + templateStatusCell(voucher) + '</td>' +
      '<td>' + truncateChars(19, voucher.voucher_title) + '</td>' +
      '<td>' + truncateChars(15, voucher.buyer_name)    + '</td>' +
      '<td>' + truncateChars(15, voucher.to_name)       + '</td>' +
      '<td>' + voucher.issue_date + '</td>' +
      '<td class="right">' + formatMoney(voucher.dollar_value) + '</td>' +
      '<td data-disable-implicit-linking>' + templateRedeemCell(voucher) + '</td>' +
    '</tr>');
}

function getFilterKeywords (data) {
  return data.filter_keywords.map(function (it) { return typeof it === 'string' ? it.toLowerCase() : ""; });
}

function getSortKeys (voucher) {
  return {
    code:   { type: "alpha",  value: voucher.voucher_code },
    type:   { type: "alpha",  value: voucher.voucher_type },
    title:  { type: "combo",  value: voucher.voucher_title },
    status: { type: "status", value: voucher.display_status },
    buyer:  { type: "alpha",  value: voucher.buyer_name },
    to:     { type: "alpha",  value: voucher.to_name },
    issue:  { type: "date",   value: voucher.issue_date_raw },
    value:  { type: "num",    value: voucher.dollar_value }
  };
}


//
// TableRow (not a widget, technically)
//

module.exports = function TableRow (data) {

  // Setup
  var dom = { main: $(templateRow(data)) };
  dom.redeem = dom.main.find('button');

  var keywords = {
    exact: data.exact_match,
    all:   getFilterKeywords(data)
  };

  // Data belonging to this row
  var sortKeys = getSortKeys(data);

  // Functions
  function matchKeywords (query) {
    var words   = query.toLowerCase().split(' ');
    var matches = words.map(function () { return false; });

    for (var w in words) {
      var word = words[w];
      for (var i in keywords.all) {
        var keyword = keywords.all[i];
        //log('Test:', keyword, word, keyword.indexOf(word)); // Dont enable on large datasets
        if ( keyword.indexOf(word) > -1 ) {
          matches[w] = true;
        }
      }
    }

    return all(matches);
  }

  function getKeyValue (key) {
    return sortKeys[key].value;
  }

  function getKeyType (key) {
    return sortKeys[key].type;
  }

  // Interface
  return {
    data:         data,
    sortKey:      getKeyValue,
    sortType:     getKeyType,
    appendTo:     function ($el) { $el.append(dom.main); },
    isRedeemable: function () { return data.redeemable; },
    keywordMatch: function (query) { return matchKeywords(query); },
    exactMatch:   function (query) { return (query === keywords.exact) }
  };
}

